<div class="rule-summary border">
	<div class="rule-summary-top">
		<h3
			class="heading-3"
			*ngIf="!rule; else clickedRule"
		>
			{{ setHeaderText() }}
		</h3>

		<ng-template #clickedRule>
			<h3 class="heading-3">{{ rule?.name || "No Rule" }}</h3>
		</ng-template>

		<div style="display: flex; gap: 1em">
			<app-action-button
				[disabled]="!rule || !rule.id"
				title="Edit"
				(buttonClicked)="editButtonClick()"
			></app-action-button>

			<app-action-button
				[disabled]="!rule || !rule.id"
				title="Close"
				(buttonClicked)="closeButtonClick()"
			></app-action-button>
		</div>
	</div>

	<div class="rule-summary-bottom">
		<p
			id="no-rule"
			class="bold"
			*ngIf="!rule || !rule?.id"
		>
			Only one rule can be viewed at a time. Select a single rule to see its summary.
		</p>
		<ngx-skeleton-loader
			count="5"
			*ngIf="!showTripDetails && rule && rule.id"
		></ngx-skeleton-loader>
		<!-- not doing an if else ng template technique because all we need is the visibility of the skeleton, the rule summary is too pushed down to bother with that logic -->
		<ng-container *ngIf="rule && rule.id">
			<p>
				<b>Excluded Zones:</b>
				{{ excludedZones$ | async }}
			</p>

			<div class="duties">
				<div class="start">
					<p class="bold">Duty Start</p>
					<app-trip-start-end
						[tripStartOrEnd]="rule?.tripStart"
						[tripZones]="startTripZones$ | async"
					></app-trip-start-end>
				</div>
				<div class="end">
					<p class="bold">Duty End</p>
					<app-trip-start-end
						[tripStartOrEnd]="rule?.tripEnd"
						[tripZones]="endTripZones$ | async"
					></app-trip-start-end>
				</div>
			</div>
		</ng-container>
	</div>
</div>
